import { matches } from '@/mocks/matches';
import { categories } from '@/mocks/categories';

export default function HotSchedule() {
  const hotMatches = matches.filter((m) => m.status === 'upcoming' && m.isHot);

  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              热门赛程
            </h2>
            <p className="mt-2 text-sm text-foreground-500">即将开赛的焦点对决，提前锁定关注</p>
          </div>
        </div>

        <div className="space-y-3">
          {hotMatches.map((match) => {
            const cat = categories.find((c) => c.id === match.categoryId);
            return (
              <div
                key={match.id}
                className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 p-4 md:p-5 rounded-lg bg-background-100 border border-background-200 hover:border-primary-200 transition-all duration-200"
              >
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                    <i className={`${cat?.icon || 'ri-trophy-line'} text-sm md:text-base`}></i>
                  </div>
                  <div>
                    <div className="flex items-center gap-2 flex-wrap">
                      <span className="text-sm md:text-base font-semibold text-foreground-900">{match.homeTeam}</span>
                      <span className="text-xs text-foreground-400 font-heading">VS</span>
                      <span className="text-sm md:text-base font-semibold text-foreground-900">{match.awayTeam}</span>
                    </div>
                    <span className="text-xs text-foreground-500">{match.league}</span>
                  </div>
                </div>

                <div className="flex items-center gap-3 sm:gap-5">
                  <div className="text-right">
                    <div className="text-xs text-foreground-500">比赛时间</div>
                    <div className="text-sm font-semibold text-foreground-800 whitespace-nowrap">{match.time}</div>
                  </div>
                  <span className="px-4 py-2 rounded-lg bg-primary-500 hover:bg-primary-600 text-white text-xs font-semibold transition-colors whitespace-nowrap cursor-pointer">
                    预约提醒
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}